import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: 'input[tsDateMask]',
  standalone: true,
})
export class TsDateMaskDirective {
  private readonly elementRef = inject<ElementRef<HTMLInputElement>>(ElementRef);
  private isFormatting = false;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.isAllowedKey(event)) {
      return;
    }

    if (/^\d$/.test(event.key)) {
      return;
    }

    event.preventDefault();
  }

  @HostListener('input')
  onInput(): void {
    if (this.isFormatting) {
      return;
    }

    const input = this.elementRef.nativeElement;
    const formattedValue = this.formatAsDate(input.value);

    if (formattedValue === input.value) {
      return;
    }

    this.isFormatting = true;
    input.value = formattedValue;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    this.isFormatting = false;
  }

  private formatAsDate(value: string): string {
    const digits = value.replace(/\D/g, '').slice(0, 8);
    const month = digits.slice(0, 2);
    const day = digits.slice(2, 4);
    const year = digits.slice(4, 8);

    if (digits.length <= 2) {
      return month;
    }

    if (digits.length <= 4) {
      return `${month}/${day}`;
    }

    return `${month}/${day}/${year}`;
  }

  private isAllowedKey(event: KeyboardEvent): boolean {
    return (
      event.ctrlKey ||
      event.metaKey ||
      event.altKey ||
      ['Backspace', 'Delete', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)
    );
  }
}
